import { isAxiosError } from 'axios';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

/** API errors and SDK rejections are not guaranteed to have the same shape. */
export const readPaymentError = (error: unknown) => {
  const value = isRecord(error) ? error : {};
  const data = isRecord(value.data) ? value.data : {};
  return {
    status: typeof value.status === 'number' ? value.status : undefined,
    code: typeof value.code === 'string' ? value.code : undefined,
    statusKey:
      typeof value.statusKey === 'string' ? value.statusKey : undefined,
    message:
      typeof data.message === 'string'
        ? data.message
        : typeof value.message === 'string'
        ? value.message
        : undefined,
  };
};

export const findSubscriptionError = (
  error: unknown,
): {
  type:
    | '401'
    | 'PG_ERROR'
    | 'ZEP_API_ERROR'
    | 'UNKNOWN_ERROR'
    | 'FAIL_TO_EDIT_ZIP_CODE';
  message: string;
} => {
  const { status, code, statusKey, message } = readPaymentError(error);
  if (code === 'ECONNABORTED') {
    return { type: 'ZEP_API_ERROR', message: message ?? code };
  }
  if (isAxiosError(error) && error.response?.status === 401) {
    return {
      type: '401',
      message: 'subscription:payment.alertFailPay.descriptionLogOut',
    };
  }
  if (status !== undefined && status < 0) {
    const key = code || statusKey || String(status);
    if ([-158, -157, -155].includes(status)) {
      return { type: 'PG_ERROR', message: message ?? key };
    }
    if (status === -211) {
      return { type: 'FAIL_TO_EDIT_ZIP_CODE', message: statusKey ?? key };
    }
    return { type: 'ZEP_API_ERROR', message: key };
  }
  return { type: 'UNKNOWN_ERROR', message: 'An error occurred' };
};
